<template>
      <button
          v-if="tutorial.published"
          @click="updatePublished(false)"
          class="action-button-sm publish"
      >
        Published
      </button>
      <button
          v-if="!tutorial.published"
          @click="updatePublished(true)"
          class="action-button-sm unpublish"
      >
        In progress
      </button>
</template>

<script>
export default {
  name: "PublishButton",
  props: {
    tutorial: {
      type: Object,
      required: true,
    },
    updatePublished: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped>

.action-button-sm {
  padding: 3px 8px;
  border: none;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  text-transform: uppercase;
  transition: background-color 0.3s;
  color: var(--my-dark);
}

.publish {
  background: linear-gradient(170deg, #34a719, #28a745);
}

.publish:hover {
  background: linear-gradient(170deg, #28a745, #218838);
}

.unpublish {
  background: linear-gradient(170deg, var(--my-links), #005bb5);
}

.unpublish:hover {
  background: linear-gradient(170deg, #005bb5, #004494);
}

.publish-button {
  width: auto;
  min-width: 150px;
}

</style>
